





























































































































import { apiOrderOrderList, apiOrderOrderPay } from '@/api'
import { computed, ref } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useApi, useLoaded } from '@/hooks'
import { defineTvListeners } from '../utils'
import { navigateTo } from '@/router'
import { prepareData, submit, Track } from '@/utils'
import { UserUtils } from '@/views/user/utils'
import { useWaterfall, XWaterfallLoad } from '@/components'

export default defineClassComponent(
  ({ ctx }) =>
    class {
      constructor() {
        Track.useMark(() => ({
          // 埋点页面名称
          page: '我的订单',
        }))

        useLoaded(this.loading, () => this.goToCategory(0))
      }

      // 加载状态
      loading = computed(() => this.apiData.loading)

      // 分类索引
      categoryIndex = ref(0)

      // 列表项目操作数量
      listItemActionCount = ref(0)

      // 列表项目操作索引
      listItemActionIndex = ref(0)

      waterfall = useWaterfall('waterfall')

      apiData = useApi(() =>
        prepareData({
          userData: UserUtils.getInfo(),
        }),
      )

      userData = computed(() => this.apiData.data.userData)

      // 加载列表数据
      loadData: XWaterfallLoad = ({ pageNumber }) => {
        return apiOrderOrderList({
          pageIndex: pageNumber,
          pageSize: 12,
          status: this.categoryIndex.value,
        }) as any
      }

      // 跳到分类
      goToCategory = (index: number) => {
        ctx.$tv.goTo(ctx.$refs.category as any, index)
      }

      // 跳到列表
      goToList = (index: number) => {
        ctx.$tv.goTo((ctx.$refs.list as any).$el, index)
      }

      // 分类监听器
      categoryListeners = defineTvListeners(({ type, index }) => {
        switch (type) {
          case 'focus':
            this.categoryIndex.value = index
            break
          default:
            break
        }
      })

      // 列表监听器
      listListeners = defineTvListeners<string>(
        ({ type, index, isFirst, isLast, el, item }) => {
          switch (type) {
            case 'focus':
              this.listItemActionCount.value =
                el.querySelector<HTMLDivElement>(
                  `.${ctx._.actions}`,
                )!.children.length
              this.listItemActionIndex.value =
                this.listItemActionCount.value - 1
              break
            case 'up':
              if (this.listItemActionIndex.value !== 0) {
                this.listItemActionIndex.value -= 1
                this.goToList(index)
              } else if (index < 3) {
                this.goToCategory(this.categoryIndex.value)
              }
              break
            case 'down':
              if (
                this.listItemActionIndex.value <
                this.listItemActionCount.value - 1
              ) {
                this.listItemActionIndex.value += 1
                this.goToList(index)
              }
              break
            case 'left':
              if (isFirst) {
                this.goToCategory(this.categoryIndex.value)
              } else {
                this.goToList(index - 1)
              }
              break
            case 'right':
              if (!isLast) {
                this.goToList(index + 1)
              } else {
                this.goToList(-1)
              }
              break
            case 'click':
              const action: '查看物流' | '订单详情' | '去付款' = el
                .querySelector<HTMLDivElement>(`.${ctx._.actions}`)!
                .children[
                  this.listItemActionIndex.value
                ].textContent!.trim() as any
              switch (action) {
                case '去付款':
                  submit(async $ => {
                    await $.start()
                    const payData = await apiOrderOrderPay({
                      orderNo: item,
                    })
                    await dcb.requestPayment({
                      provider: 'native',
                      showNativeResultPage: false,
                      params: payData,
                    })
                    await this.waterfall.reload()
                    await $.success('支付成功')
                  })
                  break
                case '订单详情':
                  navigateTo('TvOrderDetail', {
                    orderNo: item,
                  })
                  break
                case '查看物流':
                  navigateTo('TvOrderDetail', {
                    orderNo: item,
                    showExpress: true,
                  })
                  break
                default:
                  break
              }
              break
            default:
              break
          }
        },
      )
    },
)
